import { track } from '~/utils/analytics'
import { triggerRecording } from '~/utils/hud'
import { messageGift } from '~/utils/messages'
import { startScreenCapture, stopRecording } from '~/utils/recorder'

export const toggleDrawer = (toggles, toggle) => {
  if (!toggles.open) {
    messageGift('FULL_VIEWPORT')
    toggle('open')
  } else {
    toggle('open')
  }
}

export const toggleScreenshot = (
  toggleOn: Function,
  toggleOff: Function,
  setCountdown: Function,
  setImageData: Function,
  clearNotification?: Function
) => {
  const handleAccept = () => {
    toggleOff('open')
  }

  const countdown = args => {
    toggleOn('countdown')
    setCountdown(args)
  }

  const annotate = (imageData: string) => {
    if (clearNotification) {
      clearNotification()
    }
    messageGift('FULL_VIEWPORT')
    setImageData(imageData)
    toggleOn('annotate')
    toggleOff('countdown')
    const dock = document.querySelector('.dock')
    if (dock) {
      setTimeout(() => {
        dock.classList.remove('camera-shy')
        toggleOn('open')
      }, 450)
    }
  }

  toggleOn('studio')
  track('drawer_toggle_clicked', {
    toggleName: 'screenshot_started',
    placement: 'dock',
  })
  toggleOff('open')

  startScreenCapture(annotate, true, countdown)
    .then(handleAccept)
    .catch(() => {
      toggleOff('studio')
      toggleOff('annotate')
    })
}

export const toggleRecord = (
  toggles: any,
  toggleOn: Function,
  toggleOff: Function,
  setGif: Function,
  service: string,
  scheduleNotification?: Function,
  clearNotification?: Function
) => {
  const handleAccept = () => {
    toggleOff('open')
    toggleOn('recording')
    if (scheduleNotification) {
      scheduleNotification()
    }
  }

  const handleURL = (url: string) => {
    toggleOff('studio')
    setGif(url)
  }

  if (toggles.recording) {
    stopRecording()
    toggleOff('recording')
  } else {
    toggleOn('studio')
    track('drawer_toggle_clicked', {
      toggleName: 'screen_recording_started',
      placement: 'dock',
    })
    const params = {
      clear: clearNotification,
      handleAccept,
      showModal: () => {
        toggleOn('open')
        toggleOn('watching')
      },
      service,
      handleURL,
    }
    triggerRecording(params)
  }
}
